// libs
import React, { memo, useEffect, useState } from 'react';
import { styled } from '@nykaa/ui-components';

// redux
import {
  showFooterDownloadAppSection as _showFooterDownloadAppSection,
  hideFooterDownloadAppSection as _hideFooterDownloadAppSection,
} from 'shared/store/app/actions';

// constants
import { BANNER_WIDGET_ALT_TEXT, BANNER_WIDGET_HEIGHT } from './constants';

// defs
import { IBannerWidget } from 'shared/layouts/DetailsPage/components/Widgets/types';

// styles
const BannerWidget = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing.spacing40};
`;

const Image = styled.img`
  width: 100%;
  height: auto;
`;

interface IRenderBannerWidgetProps {
  widget: IBannerWidget;
  showFooterDownloadAppSection: typeof _showFooterDownloadAppSection;
  hideFooterDownloadAppSection: typeof _hideFooterDownloadAppSection;
}

function RenderBannerWidget({
  widget,
  showFooterDownloadAppSection,
  hideFooterDownloadAppSection,
}: IRenderBannerWidgetProps) {
  const [clickCount, setClickCount] = useState(0);

  const { bannerImage, action_url: actionUrl, bannerAspectRatio } = widget;
  const { showFooterAppInstall = true } = widget;

  useEffect(() => {
    if (showFooterAppInstall) {
      return;
    }

    hideFooterDownloadAppSection();

    return () => {
      showFooterDownloadAppSection();
    };
  }, [showFooterAppInstall, hideFooterDownloadAppSection, showFooterDownloadAppSection]);

  // click event
  const handleClick = () => {
    // only to track it once
    if (clickCount === 0) {
      setClickCount(clickCount + 1);
    }
  };

  return (
    <BannerWidget onClick={handleClick} href={actionUrl}>
      <Image
        src={bannerImage}
        alt={BANNER_WIDGET_ALT_TEXT}
        height={BANNER_WIDGET_HEIGHT}
        width={bannerAspectRatio * BANNER_WIDGET_HEIGHT}
        loading="lazy"
      />
    </BannerWidget>
  );
}

export default memo(RenderBannerWidget);
